import { render, staticRenderFns } from "./notpassDailog.vue?vue&type=template&id=2ef11c6e&scoped=true"
import script from "./notpassDailog.vue?vue&type=script&lang=ts"
export * from "./notpassDailog.vue?vue&type=script&lang=ts"
import style0 from "./notpassDailog.vue?vue&type=style&index=0&id=2ef11c6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef11c6e",
  null
  
)

export default component.exports